export default __webpack_public_path__ + "static/media/maskGroup@1.d1695940.png";